export default "__VITE_ASSET__Dj$eHk1D__"